export class ModuleConfiguration {
  static moduleName = 'messages';
}



// WEBPACK FOOTER //
// ./src/app/messages/messages.module.config.ts